<div class="dialog">
    <div class="dialog-title">
        <h6 class="pl-3">Edit Timeline Flag <img src="assets/svg/close-white.svg" alt="close" (click)="close()"></h6>
    </div>
    <div class="content pt-0 px-0">
        <div class="row p-4 mb-4 details mx-0 pt-2">
            <div class="col-md-4">
                <label>Part</label>
                <div class="value">{{ batchDetails?.part_name || '--' }}</div>
            </div>
            <div class="col-md-4">
                <label>Batch deadline</label>
                <div class="value">{{batchDetails?.dispatch_date || '18/03/2024' | date:'longDate'}}</div>
            </div>
            <div class="col-md-4">
                <label>Ordered Quantity</label>
                <div class="value">{{batchDetails?.ordered_quantity ||'--'}}</div>
            </div>
        </div>

        <form class="container-fluid pt-0 row mb-4 mx-0" [formGroup]="demoForm" validate>
            <label class="col-12">Timeline Flag</label>
            <div class="col-12">
                <mat-radio-group aria-label="Select an option" formControlName="timeline_flag">
                    <mat-radio-button  value="on-time">On Time</mat-radio-button>
                    <mat-radio-button  value="expecting-delay">Expecting Delay</mat-radio-button>
                    <mat-radio-button  value="delayed">Delayed</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-12 d-flex flex-column mt-4" *ngIf="demoForm.get('timeline_flag').value === 'expecting-delay' || demoForm.get('timeline_flag').value === 'delayed'">
                <label>Reason for the Delay</label>
                <textarea style="height: 150px;" type="textarea" formControlName="reason_for_delay" placeholder="Enter"
                    aria-label="Reason for the Delay"></textarea>
            </div>
            <div class="col-12 mt-4" *ngIf="demoForm.get('timeline_flag').value === 'expecting-delay' || demoForm.get('timeline_flag').value === 'delayed'">
                <label>Will it affect the Batch Deadline?</label>
                <p>You can pick a new deadline for the delivery if required.</p>
            </div>
            <div class="col-12" *ngIf="demoForm.get('timeline_flag').value === 'expecting-delay' || demoForm.get('timeline_flag').value === 'delayed'">
                <mat-radio-group aria-label="Select an option" formControlName="affected_deadline">
                    <mat-radio-button  value="no">No, it will not affect deadline</mat-radio-button>
                    <mat-radio-button  value="yes">Yes, let me update the deadline</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-12 mt-4" *ngIf="demoForm.get('affected_deadline').value === 'yes'"><label>Select Deadline Date</label>
                <div class="date-picker  row mr-0 ml-0">
                    <input type="text" [value]="revised_deadline"
                        (dateChange)="revisedDatePickerHandler($event.target.value)" matInput
                        [matDatepicker]="revisedDatePicker">
                    <mat-datepicker-toggle class="icon" matSuffix [for]="revisedDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #revisedDatePicker></mat-datepicker>
                </div>
            </div>

        </form>
    </div>
    <div class="footer row container-fluid pr-0">
        <div class="col-md-6">

        </div>
        <div class="col-md-6 d-flex button">
            <button class="white mr-2" (click)="close()">Cancel</button>
            <button class="orange ml-2" (click)="updateStage()">Submit</button>
        </div>

    </div>
</div>